var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoggerService } from '@careapp/angular-sdk';
import { AppSettings } from '../../settings/app-settings.service';
import { FormCoreComponent } from '../form-core';
var ResetFormComponent = /** @class */ (function (_super) {
    __extends(ResetFormComponent, _super);
    function ResetFormComponent(fb, logger, settings) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.logger = logger;
        _this.settings = settings;
        _this._disabled = false;
        _this._loading = false;
        _this.email = new FormControl('', Validators.compose([Validators.required]));
        _this.login = new EventEmitter();
        _this.form = new FormGroup({ email: _this.email });
        return _this;
    }
    Object.defineProperty(ResetFormComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled || this._loading) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResetFormComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (val) {
            this._loading = val;
            if (this._loading || this._disabled) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    ResetFormComponent.prototype.onSubmit = function () {
        _super.prototype.onSubmit.call(this);
    };
    return ResetFormComponent;
}(FormCoreComponent));
export { ResetFormComponent };
